<div class="app-header-wrap">
	<div class="app-season-preview" *ngIf="seasonPreview as preview">
		<span>{{ 'theme.admin.preview' | translate:{name: preview.name} }}</span>
		<p-button
			[label]="'theme.admin.quit' | translate"
			severity="secondary"
			[outlined]="true"
			size="small"
			(onClick)="quitSeasonPreview()" />
	</div>
	<div class="app-header">
	<ngx-season-atmosphere />
	<div class="app-header__start">
		<a
			*ngIf="showMenuToggle"
			(click)="toggleSidebar($event)"
			class="app-header__menu-btn"
			href="#"
			[attr.aria-label]="'Menu' | translate">
			<i class="pi pi-bars" aria-hidden="true"></i>
		</a>
		<a (click)="navigateHome()" class="app-header__logo-mobile" href="#">
			<groin-logo ariaLabel="GROIN"></groin-logo>
		</a>
		<ngx-season-mark *ngIf="seasonMark" [mark]="seasonMark"></ngx-season-mark>
	</div>

	<div class="app-header__context" *ngIf="showRestaurantContext()">
		<div class="app-header__restaurant-wrap">
			<div
				class="app-header__restaurant"
				data-tour="restaurant-switcher"
				[class.app-header__restaurant--interactive]="enableRestaurantPicker()"
				[attr.role]="enableRestaurantPicker() ? 'button' : null"
				[attr.tabindex]="enableRestaurantPicker() ? 0 : null"
				(click)="onRestaurantBarClick($event)"
				(keydown.enter)="onRestaurantBarClick($event)"
				(keydown.space)="onRestaurantBarClick($event)">
				<span class="app-header__restaurant-name">{{ currentRestaurantName || ('Choisir un restaurant' | translate) }}</span>
				<i
					*ngIf="enableRestaurantPicker()"
					class="pi pi-chevron-down app-header__restaurant-chevron"
					aria-hidden="true"></i>
			</div>
			<p-select
				*ngIf="enableRestaurantPicker()"
				#restaurantSelect
				[(ngModel)]="currentRestaurant"
				[options]="restaurantGroups"
				[group]="true"
				optionGroupLabel="label"
				optionGroupChildren="items"
				dataKey="id"
				optionLabel="nom_court"
				[filter]="true"
				filterBy="nom_court"
				filterLocale="fr"
				[filterPlaceholder]="'Rechercher…' | translate"
				[placeholder]="'Choisir un restaurant' | translate"
				appendTo="body"
				panelStyleClass="app-restaurant-select-panel"
				styleClass="app-header__restaurant-select-hidden"
				(onChange)="onRestaurantSelect($event)">
				<ng-template let-group pTemplate="group">
					<span class="app-restaurant-select__group">{{ group.label | translate }}</span>
				</ng-template>
				<ng-template let-restaurant pTemplate="item">
					<span class="app-restaurant-select__item">{{ restaurant.nom_court }}</span>
				</ng-template>
			</p-select>
		</div>
	</div>

	<div class="app-header__end">
		<div class="app-header__tools" role="toolbar" [attr.aria-label]="'Actions' | translate">
			<span data-tour="help-button">
				<p-button
					type="button"
					[text]="true"
					rounded="true"
					severity="secondary"
					styleClass="app-header__tool-btn"
					[pTooltip]="'help.menu' | translate"
					tooltipPosition="bottom"
					[attr.aria-label]="'help.menu' | translate"
					(onClick)="openHelpCenter()">
					<i class="pi pi-question-circle" aria-hidden="true"></i>
				</p-button>
			</span>

			<p-button
				type="button"
				[text]="true"
				rounded="true"
				severity="secondary"
				styleClass="app-header__tool-btn"
				[pTooltip]="currentTheme === 'dark' ? ('Thème clair' | translate) : ('Thème sombre' | translate)"
				tooltipPosition="bottom"
				[attr.aria-label]="currentTheme === 'dark' ? ('Thème clair' | translate) : ('Thème sombre' | translate)"
				(onClick)="changeTheme(currentTheme === 'dark' ? 'default' : 'dark')">
				<i class="pi" [class.pi-moon]="currentTheme === 'default'" [class.pi-sun]="currentTheme === 'dark'" aria-hidden="true"></i>
			</p-button>

			<div class="app-header__notifications" #notificationsPanel>
				<p-button
					type="button"
					[text]="true"
					rounded="true"
					severity="secondary"
					styleClass="app-header__tool-btn"
					[class.app-header__tool-btn--active]="notificationCenterOpen"
					[pTooltip]="'Notifications' | translate"
					tooltipPosition="bottom"
					[attr.aria-label]="'Notifications' | translate"
					(onClick)="toggleNotificationCenter($event)">
					<i class="pi pi-bell" [class.blinknotif]="displayNotifications.length > 0" aria-hidden="true"></i>
					<span *ngIf="displayNotifications.length > 0" class="app-header__badge">
						{{ displayNotifications.length > 9 ? '9+' : displayNotifications.length }}
					</span>
				</p-button>

				<div class="app-header__notif-panel" *ngIf="notificationCenterOpen" (click)="$event.stopPropagation()">
					<div class="app-header__notif-head">
						<h2 class="app-header__notif-title" translate>Notifications</h2>
						<span class="app-header__notif-count" *ngIf="displayNotifications.length">
							{{ displayNotifications.length }}
						</span>
					</div>

					<div *ngIf="displayNotifications.length === 0" class="app-header__notif-empty">
						<i class="pi pi-inbox" aria-hidden="true"></i>
						<p translate>Aucune notification</p>
					</div>

					<div class="app-header__notif-list" *ngIf="displayNotifications.length">
						<article
							*ngFor="let notification of displayNotifications"
							class="app-header__notif-item"
							[class.app-header__notif-item--clickable]="!!getLink(notification)"
							(click)="getLink(notification) ? onNotificationClick($event, notification) : null">
							<div class="app-header__notif-item-actions">
								<button
									type="button"
									class="app-header__notif-action"
									[attr.aria-label]="'Supprimer' | translate"
									(click)="deleteNotification(notification); $event.stopPropagation()">
									<i class="pi pi-trash" aria-hidden="true"></i>
								</button>
								<button
									*ngIf="getLink(notification)"
									type="button"
									class="app-header__notif-action"
									[attr.aria-label]="'Voir' | translate"
									(click)="onNotificationClick($event, notification); $event.stopPropagation()">
									<i class="pi pi-arrow-up-right" aria-hidden="true"></i>
								</button>
							</div>
							<div class="app-header__notif-item-body">
								<p [innerHTML]="notification.content"></p>
								<time class="app-header__notif-time">{{ notification.created_at | date: 'short' }}</time>
							</div>
						</article>
					</div>

					<div class="app-header__notif-foot" *ngIf="displayNotifications.length">
						<p-button
							type="button"
							severity="danger"
							[outlined]="true"
							size="small"
							styleClass="w-100"
							[label]="'Effacer tout' | translate"
							(onClick)="clearNotifications()" />
					</div>
				</div>
			</div>
		</div>

		<div class="app-header__divider" aria-hidden="true"></div>

		<div *appIsGranted="['view', 'user']" class="app-header__user">
			<button
				type="button"
				class="app-header__user-btn"
				data-tour="user-menu"
				[class.app-header__user-btn--compact]="userPictureOnly"
				(click)="openUserMenu($event)"
				[attr.aria-haspopup]="userMenuItems.length ? 'menu' : null"
				[attr.aria-label]="user?.firstname || ('Mon compte' | translate)">
				<span class="app-header__user-avatar-wrap">
					<ngx-user-avatar
						*ngIf="user?.id"
						[userId]="user.id"
						[firstName]="user.firstname"
						[lastName]="user.lastname"
						size="md" />
				</span>
				<span *ngIf="!userPictureOnly" class="app-header__user-meta">
					<span class="app-header__user-name">{{ user?.firstname }}</span>
					<span class="app-header__user-role" translate>Mon compte</span>
				</span>
				<i class="pi pi-chevron-down app-header__user-chevron" *ngIf="!userPictureOnly" aria-hidden="true"></i>
			</button>
			<p-menu #userMenuPopup [model]="userMenuItems" [popup]="true" appendTo="body"></p-menu>
		</div>
	</div>
</div>

<ng-template #crop let-data let-ref="dialogRef">
	<p-card>
		<ng-template pTemplate="header">Photo de profil</ng-template>
		<div>
			<image-cropper
				(cropperReady)="cropperReady()"
				(imageCropped)="imageCropped($event)"
				(imageLoaded)="imageLoaded($event)"
				(loadImageFailed)="loadImageFailed()"
				[aspectRatio]="1"
				[imageChangedEvent]="imageChangedEvent"
				[maintainAspectRatio]="true"
				[onlyScaleDown]="true"
				format="jpeg"
				imageQuality="80"
				resizeToWidth="512"
				style="max-height:50vh"></image-cropper>
		</div>
		<ng-template pTemplate="footer">
			<p-button (onClick)="ref.close()" severity="success">Annuler</p-button>
			<p-button (onClick)="uploadProfilePic(ref)" severity="success">Mettre en ligne</p-button>
		</ng-template>
	</p-card>
</ng-template>
<input #fileInput accept="image/*" (change)="onFileSelected($event)" style="display:none;" type="file" />
